import moment from 'moment'
import useOrderHooks from './hooks/useOrderHooks'
import { cnTw, formatStrAddress2 } from '@/utils'
import { Link } from 'react-router-dom'
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, getKeyValue } from '@nextui-org/react'

const columns = [
	{
		key: 'createTime',
		label: '日期 OROER ID',
	},
	{
		key: 'send',
		label: '发送',
	},
	{
		key: 'end',
		label: '接收',
	},
	{
		key: 'receiveAddress',
		label: '接收',
	},
]

export default function Order() {
	// , ...OrderArgs
	const { data: OrderData } = useOrderHooks()
	return (
		<div className="pt-[1.625rem]">
			<div className="tail-text-menu pl-2 text-2xl font-bold">已完成订单</div>
			<Table
				selectionMode="single"
				color="default"
				classNames={{
					wrapper: 'shadow-none bg-transparent border-transparent px-0',
				}}
				aria-label="big node"
			>
				<TableHeader columns={columns}>{column => <TableColumn key={column.key}>{column.label}</TableColumn>}</TableHeader>
				<TableBody items={OrderData.orderList}>
					{item => (
						<TableRow key={item.id}>
							{columnKey => {
								if (columnKey === 'createTime')
									return (
										<TableCell>
											<div className="px-2">
												{moment(item.createTime).format('MM/DD/YYYY')} <br />
												<Link to={`/ordersDetails?id=${item.id}`} className="text-[#45648B]">
													{item.orderid}
												</Link>
											</div>
										</TableCell>
									)
								if (columnKey === 'send')
									return (
										<TableCell>
											<div className="flex items-center gap-1 whitespace-nowrap px-2">
												<img src={item.send.image} className="h-3 w-3 rounded-full" alt="" />
												<span>{item.send.amount}</span>
												<span>{item.send.symbol}</span>
											</div>
										</TableCell>
									)
								if (columnKey === 'end')
									return (
										<TableCell>
											<div className="flex items-center gap-1 whitespace-nowrap px-2">
												<img src={item.end.image} className="h-3 w-3 rounded-full" alt="" />
												<span>{item.end.amount}</span>
												<span>{item.end.symbol}</span>
											</div>
										</TableCell>
									)
								if (columnKey === 'receiveAddress')
									return (
										<TableCell>
											<div className="whitespace-nowrap px-2">{formatStrAddress2(10, 10, item.receiveAddress)}</div>
										</TableCell>
									)
								return <TableCell>{getKeyValue(item, columnKey)}</TableCell>
							}}
						</TableRow>
					)}
				</TableBody>
			</Table>

			{/* <div className="mt-6 grid grid-cols-4 px-2">
				<div className="text-[0.625rem] text-[#A6A6A6]">日期\OROER ID</div>
				<div className="text-[0.625rem] text-[#A6A6A6]">发送</div>
				<div className="text-[0.625rem] text-[#A6A6A6]">接收</div>
				<div className="text-right text-[0.625rem] text-[#A6A6A6]">目标地址</div>
			</div>
			<div className="mt-2 flex flex-col w-auto gap-y-1">
				{OrderData.orderList.map((item, key) => (
					<Link
						key={key}
						to={`/ordersDetails?id=${item.id}`}
						className="group overflow-hidden overflow-x-scroll w-auto cursor-pointer flex rounded-md bg-[#151A30] text-xs text-white hover:bg-[#1F2849]"
					>
						<div className={cnTw('border-r border-transparent px-2 py-2.5', 'group-hover:border-[#233043]','min-w-[8.75rem]')}>
							{moment(item.createTime).format('MM/DD/YYYY')} <br />
							<span className="text-[#45648B]">{item.orderid}</span>
						</div>
						<div
							className={cnTw('flex items-center gap-1 border-r border-transparent px-2 py-2.5', 'group-hover:border-[#233043]', )}
						>
							<img src={item.send.image} className="h-3 w-3 rounded-full" alt="" />
							<span>{item.send.amount}</span>
							<span>{item.send.symbol}</span>
						</div>
						<div
							className={cnTw(
								'flex items-center gap-1 break-all border-r border-transparent px-2 py-2.5',
								'group-hover:border-[#233043]',
							)}
						>
							<img src={item.end.image} className="h-3 w-3 rounded-full" alt="" />
							<span>{item.end.amount}</span>
							<span>{item.end.symbol}</span>
						</div>
						<div className="break-all px-2 py-2.5">{formatStrAddress2(6, 4, item.receiveAddress)}</div>
					</Link>
				))}
			</div> */}
		</div>
	)
}
